import '../httpservices/core/ajax.httpservice.core';

class AnnouncementsHttpService {

    AnnouncementSelect(articleId) {
        return $.get('api/Announcements/Detail?articleId=' + articleId);
    }

}

export const AnnouncementsHttpSvc = new AnnouncementsHttpService();